import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SignatureState {
  signaturePath: string;
}

const initialState: SignatureState = {
  signaturePath: '',
};

const signatureSlice = createSlice({
  name: 'signature',
  initialState,
  reducers: {
    setSignaturePath: (state, action: PayloadAction<string>) => {
      state.signaturePath = action.payload;
    },
    clearSignaturePath: (state) => {
      state.signaturePath = '';
    },
  },
});

export const { setSignaturePath, clearSignaturePath } = signatureSlice.actions;
export default signatureSlice.reducer;
